/**
 * Vendor line colours in assignment order. Slot 0 is always the cheapest
 * vendor, so it gets the brand colour — that's the line the eye should land on.
 */
export const VENDOR_COLORS = ['var(--color-primary)', '#c77700', '#6b5ba8', '#00796b', '#ad1457'] as const;

export function vendorColor(index: number): string {
  return VENDOR_COLORS[index % VENDOR_COLORS.length];
}
